import css from '@styled-system/css';
import styled from '@emotion/styled';
import { Card as BaseCard } from '@medicalwebexperts/ui';

const Card = styled(BaseCard.Body)(({ p = [5, null, 8] }) => css({ p }));

export default Card;
